<template>
  <div class="container">


      <template>
<!--        <div class="form-block" v-show="extra._identity==0">-->
<!--          <p class="form-title" style="font-weight: bold;">*你的身份是？：</p>-->
<!--          <div style="display: inline-block; width: 100%;margin-top:30px;" @click="select_shenfen(1)">-->
<!--            <img style="width:100%;" src="https://themes.xjy.cn/ceping/images/shenfen1.png">-->
<!--          </div>-->
<!--          <div style="display: inline-block; width: 100%;margin-top:30px;" @click="select_shenfen(2)">-->
<!--            <img style="width:100%;" src="https://themes.xjy.cn/ceping/images/shenfen3.png">-->
<!--          </div>-->
<!--        </div>-->

<!--        <div class="form-block" v-show="extra._identity>0">-->
<!--          <div v-show="extra._identity==1" style="display: inline-block; width: 100%;margin-top:30px;" @click="select_shenfen(2)">-->
<!--            <img style="width:100%;" src="https://themes.xjy.cn/ceping/images/shenfen2.png">-->
<!--          </div>-->
<!--          <div v-show="extra._identity==2" style="display: inline-block; width: 100%;margin-top:30px;" @click="select_shenfen(1)">-->
<!--            <img style="width:100%;" src="https://themes.xjy.cn/ceping/images/shenfen4.png">-->
<!--          </div>-->
<!--        </div>-->
      </template>


      <template>
        <div class="form-block" v-show="extra._identity==1">
          <p class="form-title">*姓名</p>
          <input type="text" :placeholder="'请输入姓名'" v-model="extra.name">
        </div>

        <div class="form-block" v-show="extra._identity==1">
          <p class="form-title">*手机号</p>
          <input type="tel" placeholder="请输入手机号" v-model="extra.phone">
        </div>
<!--        <div class="form-block" v-show="extra._identity==1">-->
<!--          <input type="number" placeholder="请输入验证码" v-model="extra.code">-->
<!--          <a href="javascript:;" class="form-link" :class="{disabled: time > 0 || !extra.phone}" @click="sendCode">{{btnText}}</a>-->
<!--        </div>-->

        <div class="form-block" v-show="extra._identity==1">
          <p class="form-title">*身份</p>
          <select v-model="extra._identity2" @change="change_identity2();" style="width: 48%;">
            <option value="-请选择-" selected>-请选择-</option>
            <option value="职场人">职场人</option>
            <option value="研究生/博士">研究生/博士</option>
            <option value="大学生">大学生</option>
            <option value="高中生">高中生</option>
            <option value="初中生">初中生</option>
          </select>

          <select v-model="extra._identity3" v-show="extra._identity2 == '-请选择-' " style="width: 48%;float: right;">
            <option value="" selected>-请选择-</option>
          </select>

          <select v-model="extra._identity3" v-show="extra._identity2 == '初中生' " style="width: 48%;float: right;">
            <option value="" selected>-请选择-</option>
            <option value="初一">初一</option>
            <option value="初二">初二</option>
            <option value="初三">初三</option>
          </select>

          <select v-model="extra._identity3" v-show="extra._identity2 == '高中生' " style="width: 48%;float: right;">
            <option value="" selected>-请选择-</option>
            <option value="高一">高一</option>
            <option value="高二">高二</option>
            <option value="高三">高三</option>
          </select>

          <select v-model="extra._identity3" v-show="extra._identity2 == '大学生' " style="width: 48%;float: right;">
            <option value="" selected>-请选择-</option>
            <option value="大一">大一</option>
            <option value="大二">大二</option>
            <option value="大三">大三</option>
            <option value="大四">大四</option>
          </select>

          <select v-model="extra._identity3" v-show="extra._identity2 == '研究生/博士' " style="width: 48%;float: right;">
            <option value="" selected>-请选择-</option>
            <option value="研究生/博士">研究生/博士</option>
          </select>

          <select v-model="extra._identity3" v-show="extra._identity2 == '职场人' " style="width: 48%;float: right;">
            <option value="" selected>-请选择-</option>
            <option value="0-3年">0-3年</option>
            <option value="4-5年">4-5年</option>
            <option value="6-10年">6-10年</option>
            <option value="10年以上">10年以上</option>
          </select>

        </div>

        <div class="form-block" v-show="extra._identity==1 && (extra._identity2 == '大学生' || extra._identity2 == '研究生/博士') ">
          <p class="form-title">就读大学名称：</p>
          <input type="text" placeholder="请输入就读大学名称" v-model="extra._interest">
        </div>

      </template>

    <template>
      <div class="form-block" v-show="extra._identity==2">
        <p class="form-title" style="font-weight: bold;font-size:18px;color: #333333;">报告查询步骤：</p>
      </div>

      <div class="form-block" v-show="extra._identity==2">
        <p class="form-title" style="font-size:16px;color: #333333;"><span style="font-weight: bold;">步骤一：</span>点击“复制报告查询码”</p>
      </div>
      <div class="form-block" v-show="extra._identity==2" style="line-height:32px;font-size:16px;">
        <div style="float: left;color:#606060;">报告查询码：</div><div style="float: left;color:#019FE4;font-weight:bold; ">{{report_code}}</div><div class="code_text" @click="copy_text(report_code)" style="line-height:30px;">复制</div>
      </div>
      <div style="clear: both;"></div>
      <div class="form-block" v-show="extra._identity==2">
        <p class="form-title" style="color:#DB3843;">*报告查询码丢失将无法获取报告，一定要保存哦！</p>
      </div>

      <div class="form-block" v-show="extra._identity==2 && is_in_wx==2">
        <p class="form-title" style="font-size:16px;color: #333333;"><span style="font-weight: bold;">步骤二：</span>点击下方按钮，添加生涯班主任小询，获取报告查询链接，将复制的报告查询码输入链接，领取测评报告。</p>
      </div>
      <div class="form-block" v-show="extra._identity==2 && is_in_wx==2" style="line-height:32px;font-size:14px;">
        <a target="_blank" style="display: block;width: 140px;" class="code_text" href="https://d.uiuin.cn/cnoANu">去添加班主任</a>
      </div>


      <div class="form-block" v-show="extra._identity==2 && is_in_wx==1">
        <p class="form-title" style="font-size:16px;color: #333333;"><span style="font-weight: bold;">步骤二：</span>长按识别下方二维码，添加生涯班主任小询，获取报告查询链接，将复制的报告查询码输入链接，领取测评报告。</p>
      </div>
      <div class="form-block" v-show="extra._identity==2 && is_in_wx==1" style="line-height:32px;font-size:14px;">
        <img style="width:100%;padding: 0 10%;" src="https://themes.xjy.cn/ceping/images/shenfen_qrcode.jpg">
      </div>

    </template>



    <div class="form-block pt50" v-show="extra._identity==1">
      <a href="javascript:;" class="form-btn" :class="{disabled: !canSubmit}" @click="saveUserInfo_i">生成测评报告</a>
    </div>




  </div>
</template>

<script>
import { send_sms,check_sms } from "@/api/xuandui_gadgets";
import { submit_mantis } from '@/api/measurement';

export default {
  data() {
    return {
      extra: {"_identity2":"-请选择-","_identity3":"","_identity":1,"_interest":""},
      btnText: '发送验证码',
      time: 0,
      sms_info: {},
      is_in_wx: 0
    }
  },
  props:['extraObj','query','cid','skip','report_code'],
  computed: {
    canSubmit() {
      // let fields = Object.keys(this.extraObj);
      // if(fields.includes('phone')) {
      //   fields.push('code');
      // }
      // for(let i = 0; i < fields.length; i++) {
      //   if(!this.extra[fields[i]]) {
      //     return false;
      //   }
      // }
      return true;
    }
  },
  methods: {
    select_shenfen(type){
      this.extra._identity = type;
      let obj = {"ck_identity":type,"code":this.report_code};
      return this.$emit('ck_identity_api', obj);
    },
    copy_text(msg) {
      const save = function(e) {
        e.clipboardData.setData('text/plain', msg)
        e.preventDefault() // 阻止默认行为
      }
      document.addEventListener('copy', save) // 添加一个copy事件
      document.execCommand('copy') // 执行copy方法
      this.$toast('复制成功');
    },
    saveUserInfo_i() {

      let fields = Object.keys(this.extraObj);
      let common_fields = ['name', 'phone', '_identity', '_identity2', '_identity3', '_interest'];

      console.log(fields);
      console.log(this.extra);
      console.log(this.extra._identity2);
      console.log(!this.extra._identity2);
      console.log(this.extra._identity2=="-请选择-");

      console.log(!this.extra._identity3);

      // return;

      if(fields.includes('_identity2')) {
        if (!this.extra._identity2 || this.extra._identity2 == "-请选择-") {
          this.$toast('请选择身份');
          return;
        } else {
          if (!this.extra._identity3) {
            this.$toast('请选择身份.');
            return;
          } else {
            if (this.extra._identity2 == "初中生") {
              var _identity3_arr = ["初一", "初二", "初三"];
            }
            if (this.extra._identity2 == "高中生") {
              var _identity3_arr = ["高一", "高二", "高三"];
            }
            if (this.extra._identity2 == "大学生") {
              var _identity3_arr = ["大一", "大二", "大三", "大四"];
            }
            if (this.extra._identity2 == "研究生/博士") {
              var _identity3_arr = ["研究生/博士"];
            }
            if (this.extra._identity2 == "职场人") {
              var _identity3_arr = ["0-3年","4-5年","6-10年","10年以上"];
            }
            if (_identity3_arr.indexOf(this.extra._identity3) < 0) {
              this.$toast('请选择身份。');
              return;
            }
          }
        }
      }

      if(fields.includes('name') && !this.extra.name) {
        this.$toast('请输入姓名');
        return;
      }
      if(fields.includes('phone') && !this.extra.phone) {
        this.$toast('请输入手机号');
        return;
      } else if (fields.includes('phone') && !/^1[3-9][0-9]{9}$/.test(this.extra.phone)) {
        this.$toast('手机号码不正确');
        return;
      }

      // if(fields.includes('phone') && !this.extra.code) {
      //   this.$toast('请输入验证码');
      //   return;
      // }

      if(fields.includes('_identity') && !this.extra._identity) {
        this.$toast('请选择身份');
        return;
      }

      if(fields.includes('_interest') && !this.extra._interest) {
        // this.$toast('请输入就读大学');
        // return;
      }


      // if(fields.includes('phone') && !this.sms_info.sms_id) {
      //   this.$toast('请重新验证');
      //   return;
      // }

      if(fields.includes('phone')) {
        // check_sms({sms_id: this.sms_info.sms_id, code: this.extra.code}).then(res=>{
        //   if(res.error>0) {
        //     return Promise.reject(res.msg);
        //   }
        //   if(this.sms_info.phone != this.extra.phone) {
        //     return Promise.reject('请重新验证');
        //   }
        //   this.submit();
        // }).catch(msg=>{
        //   if(!msg) {
        //     this.$toast(msg);
        //   }
        // });
        this.submit();
      } else {
        this.submit();
      }
    },
    submit() {
      this.extra.is_student = 1;
      // if(this.skip) {
        return this.$emit('saveUserInfo_i', this.extra);
      // }
      // submit_mantis({
      //   cid: this.cid,
      //   lead_sid: this.query.lead_sid,
      //   content: JSON.stringify(this.extra),
      //   order: this.query.order || 0,
      //   sid: this.query.sid,
      // }).then(data=>{
      //   if (data.code == 10002) {
      //     this.$toast(data.msg);
      //     return;
      //   }
      //   this.$emit('saveUserInfo_i', this.extra);
      // });
    },
    sendCode() {
      if(this.time > 0) {
        return;
      }

      if(!this.extra.phone) {
        this.$toast('请输入手机号');
        return;
      } else if (!/^1[3-9][0-9]{9}$/.test(this.extra.phone)) {
        this.$toast('手机号码不正确');
        return;
      }

      send_sms({mobile: this.extra.phone}).then(res=>{
        if(res.error > 0) {
          if(res.msg) {
            this.$toast(res.msg);
          }
          return;
        }

        this.sms_info.phone = this.extra.phone;
        this.sms_info.sms_id = res.sms_id;

        this.time = 60;
        this.btnText = `${this.time}s`;
        let t = setInterval(()=>{
          if(this.time > 0) {
            this.time--;
            this.btnText = `${this.time}s`;
          } else {
            clearInterval(t);
            this.btnText = '重新发送';
          }
        }, 1000);

      }).catch(msg=>{
        if(!msg) {
          this.$toast(msg);
        }
      });
    }
    ,change_identity2(){
      this.extra._identity3 = "";
    }
  },
  mounted(){
    document.title = '个人信息提交';
    var ua = window.navigator.userAgent.toLowerCase();//通过正则表达式匹配ua中是否含有MicroMessenger字符串
    if (ua.match(/MicroMessenger/i) == 'micromessenger' ) {
      this.is_in_wx = 1;
    } else {
      this.is_in_wx = 2;
    }
    select_shenfen(1)
  }
};
</script>

<style lang="scss" scoped>
.form-block {
  padding: 30px 30px 0;
  position: relative;

  &.pt50 {
    padding-top: 100px;
  }

  .form-title {
    padding: 10px 0 0;
    margin: 0 0 16px 0;
    font-size: 28px;
    font-weight: 400;
    color: #606060;
    line-height: 40px;
  }

  .form-link {
    width: 150px;
    height: 40px;
    font-size: 28px;
    font-weight: 600;
    color: #F57F17;
    line-height: 40px;
    text-align: center;
    position: absolute;
    top: 50%;
    right: 60px;
    margin-top: -5px;

    &.disabled {
      color: #ccc;
    }
  }

  .form-btn {
    display: inline-block;
    width: 100%;
    height: 100px;
    background: #F57F17;
    border-radius: 50px;
    line-height: 100px;
    text-align: center;
    font-size: 36px;
    font-weight: 600;
    color: #fff;
    letter-spacing: 0.5em;

    &.disabled {
      background-color: #ccc;
    }
  }

  .form-check {
    display: inline-block;
    box-sizing: border-box;
    width: 300px;
    height: 48px;
    line-height: 48px;
    font-size: 32px;
    font-weight: 400;
    color: #333333;
    line-height: 48px;
    position: relative;
    padding-left: 1.5em;

    & > input[type="checkbox"], & > input[type="radio"] {
      display: none;

      & + span:before {
        content: ' ';
        width: 1em;
        height: 1em;
        border-radius: 50%;
        background: #999;
        position: absolute;
        top: 50%;
        left: 0;
        margin-top: -0.5em;
      }

      &:checked + span:before {
        background: #F57F17;
      }

      & + span:after {
        content: ' ';
        width: 0.375em;
        height: 0.15em;
        border: 1PX solid #f5f5f5;/*no*/
        border-top: none;
        border-right: 0;
        position: absolute;
        top: 50%;
        left: 0.5em;
        margin-top: -0.15em;
        transform: translate(-50%) rotate(-45deg);
        transform-origin: center;
      }
    }
  }

  input, select {
    -webkit-appearance: none;
  }

  input::placeholder {
    color: #ccc;
  }

  input[type="text"], input[type="tel"], input[type="number"] {
    box-sizing: border-box;
    border: none;
    width: 100%;
    height: 96px;
    background: #fff;
    border-radius: 8px;
    line-height: 96px;
    padding: 0 30px;
    font-size: 28px;
    color: #333;
    outline: none;
  }

  select {
    box-sizing: border-box;
    border: none;
    width: 100%;
    height: 96px;
    background: #fff;
    border-radius: 8px;
    line-height: 96px;
    padding: 0 30px;
    font-size: 28px;
    color: #333;
    outline: none;
  }

}

.container{
  position: fixed;
  width: 100%;
  max-width: 750px;
  left: 50%;
  transform: translateX(-50%);
  top: 0;
  height: 100%;
  background-color: #f5f5f5;
  overflow: auto;
  box-sizing: border-box;
  padding-bottom: 40px;
}

.code_text{
  width:120px;
  //height: 30px;
  background: rgba(0,161,230,0.2);
  border-radius: 8px;
  border: 1px solid #019FE4;
  //line-height:30px;
  text-align: center;
  color: #0094d3;
  float: left;
  margin-left: 5px;
  //font-size:14px;
}
.code_text span{
  font-weight: bolder;
  margin-right:8px;
}
</style>